import {getCookie} from '../common';
import {PostHogConst} from 'consts';

export const getPostHogCookie = () => {
    return getCookie(`${PostHogConst.cookie_prefix}${PostHogConst.token}${PostHogConst.cookie_ending}`);
};
